registerComponent("pages/contents-internal", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 */

});
